import { AdminBankModal } from "@components/admin-bank-modal";
import { Block } from "@components/block";
import { Button } from "@components/button";
import { Config, Table } from "@components/table";
import { useBoolState } from "@hooks/use-bool-state";
import styles from "./banks.module.scss";
import { Grid, GridCol } from "@components/grid";
import { useAdminBanks } from "@features/admin/banks";
import { useEffect } from "react";
import { AdminBank } from "@features/admin/banks/api";
import { store } from "@app/store";
import {
  setRegexes,
  setSelectedBank,
} from "@features/admin/banks/slice";

export const AdminBanksPage = () => {
  const adminBanksConfig: Config<AdminBank> = [
    {
      label: "Название",
      source: "name",
    },
    {
      label: "Статус TODO",
      source: "alias",
      renderComponent: (cellData: string) => (
        <>{cellData ? "Активен" : "Не проверен"}</>
      ),
    },
    {
      label: "Действия",
      source: "id",
      renderComponent: (cellData: string, item: AdminBank) => {
        return (
          <Grid>
            <GridCol span={4}>
              <Button onClick={() => onEditClick(item)}>Редактировать</Button>
            </GridCol>
            <GridCol span={4}>
              <Button>Отключить TODO</Button>
            </GridCol>
            <GridCol span={4}>
              <Button
                onClick={() => {
                  deleteAdminBank(cellData).then(() => getAdminBanks());
                }}
              >
                Удалить
              </Button>
            </GridCol>
          </Grid>
        );
      },
    },
  ];

  const [isModalOpen, showModal, hideModal] = useBoolState(false);
  const { state, getAdminBanks, deleteAdminBank } = useAdminBanks();

  useEffect(() => {
    getAdminBanks();
  }, [getAdminBanks]);

  const onAddClick = () => {
    store.dispatch(setRegexes([]));
    showModal();
  };
  const onEditClick = (item: AdminBank) => {
    store.dispatch(setSelectedBank(item));
    store.dispatch(setRegexes(item.regexes));

    showModal();
  };

  return (
    <>
      <Button className={styles.addBtn} onClick={onAddClick}>
        Добавить
      </Button>
      <Block>
        <Table config={adminBanksConfig} data={state.banks} loading={state.loading}></Table>
        <AdminBankModal isModalOpen={isModalOpen} hideModal={hideModal} />
      </Block>
    </>
  );
};
